import changePasswordTemplate from './change_password.template.html';

class WbChangePasswordController {

    constructor($rootScope, MemberService, LoginService, halClient, LoadingService, $q, $scope, ValidatorService, AlertService) {
        'ngInject';

        const injectables = {
            $rootScope,
            MemberService,
            LoginService,
            halClient,
            LoadingService,
            $q,
            $scope,
            ValidatorService,
            AlertService
        };

        Object.assign(this, injectables);
    }

    $onInit() {
        // Initialise the loading spinner
        this.loader = this.LoadingService.$loader(this.$scope);
    }

    updatePassword() {
        this.loader.notLoaded();
        this.currentPasswordIncorrect = false;
        let self = this;

        // Check the current password, if it is correct then update the password
        self.checkPassword().then(results => {
            // Current password is correct, go ahead and update the password
            return self.LoginService.updatePassword(self.member, {
                current_password: self.currentPassword,
                new_password: self.password,
                confirm_new_password: self.passwordConfirmation
            });
        }, err => {
            // Current password is wrong so display the incorrect password message
            self.currentPasswordIncorrect = true;
            return self.$q.reject();
        }).then(result => {
            // Succesfully updated the password so display the message
            self.loader.setLoaded();
            self.AlertService.success({
                title: "Success",
                msg: "Password changed successfully"
            });
        }, err => {
            if (!self.currentPasswordIncorrect) {
                // Current password was correct, but there was another problem, display an error
                self.AlertService.error({
                    title: "Error",
                    msg: err.data.details.join(', ')
                });
            }
            self.loader.setLoaded();
        });
    }

    /**
     * Returns a promise that resolves if the current password is correct or is rejected
     * if it is not
     */
    checkPassword() {
        // Make a login request to check whether the password is correct
        let url = `${this.$rootScope.bb.api_url}/api/v1/login/${this.member.company_id}`;
        const loginForm = {
            email: this.member.email,
            password: this.currentPassword
        };
        const options = {
            company_id: this.member.company_id
        };
        return this.halClient.$post(url, options, loginForm);
    }
}

const WbChangePasswordComponent = {
    templateUrl: changePasswordTemplate.id,
    controller: WbChangePasswordController,
    controllerAs: '$wbChangePasswordCtrl',
    bindings: {
        member: '<'
    }
};

angular
    .module('westBerkshireEvents.changePassword')
    .component('wbChangePassword', WbChangePasswordComponent);

export default WbChangePasswordController;


// WEBPACK FOOTER //
// ../src/public/javascripts/change-password/change_password.component.js